import {FundValuationSensitivityCompact} from "./fund-valuation-sensitivity-compact";

export interface FundValuationSensitivityOverview {
    fundValuationId?: number;
    outdated?: boolean;
    fundValuationSensitivities?: FundValuationSensitivityCompact[];
    lastUsedStep?: number;
    lastUsedSteps?: number;
    lastUsedParamType?: "DISCOUNT_RATE_DELTA" | "EXIT_MULTIPLE_DELTA" | "TIMING_IN_QTRS_DELTA" | "UNDRAWN_MULTIPLE_DELTA";
}

export const EMTPY_FUND_VALUATION_SENSITIVITY_OVERVIEW: FundValuationSensitivityOverview = {
    fundValuationId: undefined,
    outdated: undefined,
    fundValuationSensitivities: [],
    lastUsedStep: undefined,
    lastUsedSteps: undefined,
    lastUsedParamType: undefined
}
